import {
  DeviceRequest,
  DeleteProvisioningDeviceRequest,
  ReadDevicesRequest,
  ReadProvisioningDevicesRequest,
  CreateDeviceExportJobRequest,
  CreateDeviceProvisioningExportJobRequest,
} from '@openapi';
import { Device } from '@services/types';
import { getDevicesApi, getProvisionedDevicesApi } from './configuration';

const devicesEndpoints = {
  getDevices: (requestParameters?: ReadDevicesRequest) => {
    return getDevicesApi().readDevices(requestParameters);
  },
  updateDevice: (deviceId: Device['id'], device: DeviceRequest) => {
    return getDevicesApi().updateDevice({ deviceRequest: device, id: deviceId });
  },
  deleteDevice: (deviceId: Device['id']) => {
    return getDevicesApi().deleteDevice({ id: deviceId });
  },
  getDevice: (deviceId: Device['id']) => {
    return getDevicesApi().readDevice({ id: deviceId });
  },
  reinitializeTryCounter: (deviceId: Device['id']) => {
    return getDevicesApi().reinitializeTryCounter({ id: deviceId });
  },

  exportDeviceJob: (requestParameters?: CreateDeviceExportJobRequest) => {
    return getDevicesApi().createDeviceExportJob(requestParameters);
  },
};
const devicesProvisionedEndpoints = {
  getProvisionedDevices: (requestParameters?: ReadProvisioningDevicesRequest) => {
    return getProvisionedDevicesApi()
      .readProvisioningDevices(requestParameters)
      .then((element) => element);
  },
  deleteProDevice: (requestParameters: DeleteProvisioningDeviceRequest['macAddress']) => {
    return getProvisionedDevicesApi().deleteProvisioningDevice({
      macAddress: requestParameters,
    });
  },
  exportDeviceProvisioned: (requestParameters?: CreateDeviceProvisioningExportJobRequest) => {
    return getProvisionedDevicesApi().createDeviceProvisioningExportJob(requestParameters);
  },
};
const filterDeviceVersions = {
  getLoaderVersions: () => {
    return getDevicesApi().readDeviceLoaderVersions();
  },
  getFirmwareVersions: () => {
    return getDevicesApi().readDeviceFwVersions();
  },
  getUiVersions: () => {
    return getDevicesApi().readDeviceUiVersions();
  },
  getCFW1Versions: () => {
    return getDevicesApi().readDeviceCustofw1Versions();
  },
  getCFW2Versions: () => {
    return getDevicesApi().readDeviceCustofw2Versions();
  },
  getCFW3Versions: () => {
    return getDevicesApi().readDeviceCustofw3Versions();
  },
};
const devices = {
  ...devicesEndpoints,
  ...devicesProvisionedEndpoints,
  ...filterDeviceVersions,
};
export default devices;
